module.exports = __webpack_public_path__ + "static/media/tip.8eb58232.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tip.svg
// module id = 1326
// module chunks = 1